/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Preview_Default_HintInputs */

const cs_builder_preview_default_hint = /** @type {(inputs: Builder_Preview_Default_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Náhled je otevřený automaticky — kontrolujte věrnost při úpravách.`)
};

const en_builder_preview_default_hint = /** @type {(inputs: Builder_Preview_Default_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preview opens automatically — check fidelity as you edit.`)
};

/**
* | output |
* | --- |
* | "Preview opens automatically — check fidelity as you edit." |
*
* @param {Builder_Preview_Default_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_preview_default_hint = /** @type {((inputs?: Builder_Preview_Default_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Preview_Default_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_preview_default_hint(inputs)
	return cs_builder_preview_default_hint(inputs)
});